let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iU4ZK")).then(() => parcelRequire('guD2W'));